import { render, staticRenderFns } from "./claster-selector.vue?vue&type=template&id=8fe12026&scoped=true&"
import script from "./claster-selector.vue?vue&type=script&lang=js&"
export * from "./claster-selector.vue?vue&type=script&lang=js&"
import style0 from "./claster-selector.vue?vue&type=style&index=0&id=8fe12026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe12026",
  null
  
)

export default component.exports